// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/kasi-economy-new-registration-form/kasi-economy-new-registration-form.component.scss
// module id = 1071
// module chunks = 0